/**
 * @author      carlos.soto@zumper.com (Carlos J. Soto)
 * @copyright   Copyright (c) 2024, Zumper
 * @description RentalResourcesSubmenu
 */

import { MenuGroup } from '@zcode-ui/shadz-ui'
import * as React from 'react'
import { RENTAL_RESOURCE_LINKS } from '../../../../constants/index'
import { useUserMenuContext } from '../../../../module/context/UserMenuContext'
import { UserMenuLinkRow } from '../../SharedComponents'

export const RentalResourcesSubmenu = () => {
  const { dispatchTrackUserMenuClick } = useUserMenuContext()
  return (
    <MenuGroup>
      {RENTAL_RESOURCE_LINKS.map((link) => (
        <UserMenuLinkRow
          key={link.href}
          href={link.href}
          onClick={() => dispatchTrackUserMenuClick(link.trackingName)}
        >
          {link.name}
        </UserMenuLinkRow>
      ))}
    </MenuGroup>
  )
}
